import { registerComponent } from '../app'
import Cart from '../services/Cart'

const CheckoutButton = (scope, el) => {
	const props = {
		loadingClass: 'button--loading'
	}

	el.addEventListener('click', e => {
		el.classList.add(props.loadingClass)
		Cart.checkout().then(() => el.classList.remove(props.loadingClass))
	})
}

registerComponent('checkout-button', CheckoutButton)
